module.exports = __webpack_public_path__ + "img/danger_icon.c0aaccaa.svg";